import type { FC } from 'react';
import { TournamentCard } from '@/modules/tournaments/components/TournamentCard';
import type { TTournamentSlide } from '../..';
import { ShowAllCard } from '../ShowAllCard';

interface ITournamentSlide {
  slide: TTournamentSlide;
}

export const TournamentSlide: FC<ITournamentSlide> = ({ slide }) => {
  if ('type' in slide) {
    return <ShowAllCard />;
  }
  return <TournamentCard {...slide} preview />;
};
